import React from 'react';
import Modal from '../../../Components/Modal';
import Form, { Actions, Conditional, EventTriggers, Switch, ULID, WorkingHours } from '../../../Components/Form';
import { eventTriggers } from '../../../Data/Misc';
import { useCalendarContext } from '../Provider';

const ReplanDay = ({day, missingJobIds, availability, addMissingAppointments, onClose, refresh}) => {

    return <Modal title="Replan day" isOpen={!!day} setIsOpen={onClose} dismissible>
        {day && <Inner {...{day, availability, missingJobIds, addMissingAppointments, refresh}} />}
    </Modal>
}

const Inner = ({day, missingJobIds, availability, addMissingAppointments, refresh}) => {
    const {jobsMovedTo} = useCalendarContext();

    const handleSubmit = async (data) => {
        return addMissingAppointments({
            ...data,
            date: day.date,
            jobIds: [
                ...missingJobIds,
                ...jobsMovedTo(false, day.date).map(move => move.jobId),
            ],
        });
    }
    return <div>

        <Form data={{availability}} onSubmit={handleSubmit} afterSubmit={refresh} closeModalOnSubmit>
            <ULID name="optimisationToken" />
            <WorkingHours name="availability" label="Working hours" onlyDays={[day.name]} />
            <Switch name="confirm"
                label="Confirm scheduled jobs"
                help={(val) => val ?
                        'Schedule jobs immediately. Customers may be notified' :
                        'You\'ll need to confirm before jobs are scheduled.'
                    }
            />
            <Conditional condition={d => d.confirm}>
                <EventTriggers triggers={[eventTriggers.SEND_NOTIFICATIONS]} />
            </Conditional>
            <Actions submit={{label: 'Replan day'}} cancel />
        </Form>
    </div>
}

export default ReplanDay;
